module.exports = __webpack_public_path__ + "img/discount_bg.84d51d5e.png";